module.exports = __webpack_public_path__ + "media/images/flags/am-f489f0616118c70be042340fdb89f716.svg";